export {BatteryStatusService} from './plugin/battery-status';
export {CameraService} from './plugin/camera';
export {DeviceService} from './plugin/device';
export {DeviceMotionService} from './plugin/device-motion';
export {DeviceOrientationService} from './plugin/device-orientation';
export {DialogsService} from './plugin/dialogs';
export {FacebookService} from './plugin/facebook';
export {FirebaseService} from './plugin/firebase';
export {GeolocationService} from './plugin/geolocation';
export {KeyboardService} from './plugin/keyboard';
export {MediaService} from './plugin/media';
export {NetworkInformationService} from './plugin/network-information';
export {SplashscreenService} from './plugin/splashscreen';
export {StatusbarService} from './plugin/statusbar';
export {StripeService} from './plugin/stripe';
export {VibrationService} from './plugin/vibration';
export {Cordova} from './plugin/cordova';
